import * as actionTypes from '../actionTypes/notificationActionTypes';

// Connection Status
export const setSSEConnectionStatus = (status) => {
  return {
    type: actionTypes.SSE_CONNECTION_STATUS,
    status: status
  };
};

// Receive Notification
export const receiveNotification = (notification) => {
  return {
    type: actionTypes.RECEIVE_NOTIFICATION,
    notification: notification
  };
};

// Clear Notifications
export const clearNotifications = () => {
  return {
    type: actionTypes.CLEAR_NOTIFICATIONS
  };
};

// Update Reminder Data
export const updateReminderData = (reminderData) => {
  return {
    type: actionTypes.UPDATE_REMINDER_DATA,
    reminderData: reminderData
  };
};

// New Reminder
export const reminderNew = (reminder) => {
  return {
    type: actionTypes.REMINDER_NEW,
    reminder: reminder
  };
};

// Reminder Dismissed
export const reminderDismissed = (reminderId) => {
  return {
    type: actionTypes.REMINDER_DISMISSED,
    reminderId: reminderId
  };
};

// Update Mail Data
export const updateMailData = (mailData) => {
  return {
    type: actionTypes.UPDATE_MAIL_DATA,
    mailData: mailData
  };
};

// New Mail
export const mailNew = (mail) => {
  return {
    type: actionTypes.MAIL_NEW,
    mail: mail
  };
};

// Mail Updated
export const mailUpdated = (mail) => {
  return {
    type: actionTypes.MAIL_UPDATED,
    mail: mail
  };
};


